export const cookieKeys = {
  TB_NOTICE_MODAL: 'TB_NOTICE_MODAL',
  COINONE_ACCESS_TOKEN: 'COINONE_ACCESS_TOKEN',
};
